import { useState } from 'react'
import * as roomHub from '../hub/roomHub'
import '../css/App.css'

/**
 * 진행 중 게임 복귀 모달 (2026-05-06)
 *   App.tsx 자동 복귀 트리거 시 노출.
 *   [예]   → 기존 동작 (Room 또는 Play 페이지 진입, 룸코드 유지)
 *   [아니오] → handleForfeitGame 동등 (RoomLeave invoke + lobby 이동)
 *             다른 플레이어는 빈 자리 그대로 게임 계속.
 */
interface Props {
  roomCode:   string
  isStarted:  boolean   // STARTED면 카탄 진행 중, 아니면 룸 대기 중
  onResume:   () => void
  onForfeit:  () => void  // forfeit 완료 후 lobby로 (App.tsx가 처리)
}

export default function ResumeGameModal({ roomCode, isStarted, onResume, onForfeit }: Props) {
  const [busy,   setBusy]   = useState(false)
  const [errMsg, setErrMsg] = useState('')

  async function handleNo() {
    setBusy(true)
    setErrMsg('')
    try {
      // BG_ROOM_MEMBER row 삭제 — RoomHub.LeaveRoom invoke (handleForfeitGame과 동일 동작)
      await roomHub.roomLeave(roomCode)
    } catch {
      // invoke 실패해도 클라 측 정리는 진행 (서버 측 grace 30분 후 자동 정리)
    }
    setBusy(false)
    onForfeit()
  }

  return (
    <div className="modal-overlay">
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">진행 중인 게임</h3>

        <p className="modal-desc">
          {isStarted
            ? '진행 중인 게임이 있습니다. 계속 진행하시겠습니까?'
            : '참여 중인 룸이 있습니다. 계속 진행하시겠습니까?'}
        </p>
        <p className="modal-desc-sub">
          룸코드: <strong className="resume-room-code">{roomCode}</strong>
        </p>
        <p className="modal-desc-sub" style={{ color: '#fca5a5', fontSize: 12 }}>
          [아니오] 선택 시 자리가 영구 정리되며 재진입 불가합니다.<br />
          다른 플레이어는 빈 자리 그대로 게임을 계속합니다.
        </p>

        {errMsg && <p className="modal-err">{errMsg}</p>}

        <div className="modal-btns">
          <button
            className="btn-cancel"
            onClick={handleNo}
            disabled={busy}
            title="자리 영구 정리 + lobby 이동"
          >
            {busy ? <span className="spinner" /> : null}아니오 (포기)
          </button>
          <button
            className="btn-primary"
            onClick={onResume}
            disabled={busy}
            autoFocus
          >
            예 (계속)
          </button>
        </div>
      </div>
    </div>
  )
}
